import { render, staticRenderFns } from "./modelTestStatisticRow.vue?vue&type=template&id=fa0f6a94&scoped=true"
import script from "./modelTestStatisticRow.vue?vue&type=script&lang=js"
export * from "./modelTestStatisticRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0f6a94",
  null
  
)

export default component.exports